export default [
    {
        value: 'EARLY_BIRD_1',
        text: 'Early Bird 1'
    },
    {
        value: 'EARLY_BIRD_2',
        text: 'Early Bird 2'
    },
];